/**
 * Redes do menu de compartilhamento.
 *
 * O critério é duplo: a rede precisa ter um *intent* web que aceite URL, e
 * precisa consumir o card OG/Twitter que o `SeoMetaTags` já emite — senão o
 * leitor compartilharia um link cru, sem título nem imagem.
 *
 * Ficam de fora Instagram e TikTok: nenhum dos dois aceita link de terceiros
 * por deeplink na web, então o card OG nunca seria usado.
 */

export type ShareNetworkToken =
  | 'facebook'
  | 'whatsapp'
  | 'x'
  | 'linkedin'
  | 'telegram'
  | 'email';

export interface ShareNetwork {
  token: ShareNetworkToken;
  label: string;
  /** Monta o intent a partir da URL e do título da notícia. */
  buildUrl: (url: string, title: string) => string;
}

const enc = encodeURIComponent;

export const SHARE_NETWORKS: ShareNetwork[] = [
  {
    token: 'facebook',
    label: 'Facebook',
    buildUrl: (url) =>
      `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
  },
  {
    token: 'whatsapp',
    label: 'WhatsApp',
    buildUrl: (url, title) =>
      `https://api.whatsapp.com/send?text=${enc(`${title} ${url}`.trim())}`,
  },
  {
    token: 'x',
    label: 'X',
    buildUrl: (url, title) =>
      `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`,
  },
  {
    token: 'linkedin',
    label: 'LinkedIn',
    buildUrl: (url) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`,
  },
  {
    token: 'telegram',
    label: 'Telegram',
    buildUrl: (url, title) =>
      `https://t.me/share/url?url=${enc(url)}&text=${enc(title)}`,
  },
  {
    token: 'email',
    label: 'E-mail',
    buildUrl: (url, title) =>
      `mailto:?subject=${enc(title)}&body=${enc(`${title}\n\n${url}`)}`,
  },
];

/** As duas que ganham botão próprio na régua, como no design. */
export const PRIMARY_NETWORKS: ShareNetworkToken[] = ['facebook', 'whatsapp'];
